// Utility functions for class data manipulation

export const classNameToId = (className) => {
  if (!className || typeof className !== 'string') return '';
  
  // Convert class name to a normalized ID format
  return className
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
};

export const getClassName = (classObj) => {
  if (!classObj) return '';
  return classObj.name || classObj.className || classObj.displayName || '';
};

export const getClassId = (classObj) => {
  if (!classObj) return null;
  return classObj.id || classObj._id || classObj.classId || null;
};

export const getClassYear = (classObj) => {
  if (!classObj) return null;
  return classObj.year || classObj.grade || classObj.level || null;
};

export const formatClassForDisplay = (classObj) => {
  if (!classObj) return null;
  
  const name = getClassName(classObj);
  const year = getClassYear(classObj);
  
  return {
    id: getClassId(classObj) || classNameToId(name),
    name,
    year,
    displayName: year ? `${name} (Grade ${year})` : name,
    ...classObj
  };
};

export const sortClassesByYear = (classes) => {
  if (!Array.isArray(classes)) return [];

  return classes.sort((a, b) => {
    // If both have sortOrder field, sort by sortOrder first (highest number at top)
    const hasSortOrderA = typeof a.sortOrder === 'number';
    const hasSortOrderB = typeof b.sortOrder === 'number';

    if (hasSortOrderA && hasSortOrderB) {
      return b.sortOrder - a.sortOrder; // Descending order (highest first)
    }

    // If only one has sortOrder, prioritize it
    if (hasSortOrderA) return -1;
    if (hasSortOrderB) return 1;

    // Fall back to year sorting
    const yearA = getClassYear(a) || 999;
    const yearB = getClassYear(b) || 999;

    if (yearA !== yearB) {
      return yearA - yearB;
    }

    return getClassName(a).localeCompare(getClassName(b));
  });
};